<script lang="ts">
  import { getContext } from 'svelte';

  export let cashback: number | undefined = 0;
  export let cashback_text: string = '';

  type CashbackPosition = 'corner' | 'round';
  type CashbackBackground = 'gradient' | 'solid';
  type CashbackSize = 'normal' | 'large';

  export let position: CashbackPosition = getContext<CashbackPosition>('cashbackPosition') ?? 'corner';
  export let background: CashbackBackground = getContext<CashbackBackground>('cashbackBackground') ?? 'gradient';
  export let size: CashbackSize = getContext<CashbackSize>('cashbackSize') ?? 'normal';
</script>

{#if cashback_text}
  <div class="cashback cashback_text {position} {background} {size}">{cashback_text}</div>
{:else}
  <div class="cashback {position} {background} {size}">{cashback} %</div>
{/if}
